class AboutHeroScrollAnimation {
  constructor() {
    this.heroSection = document.querySelector('.about-hero');
    this.heroImage = document.querySelector('.about-hero__image');
    
    this.initialScale = 1.0;
    this.maxScale = 1.0;
    this.currentScale = 1.0;
    this.animationProgress = 0;
    
    this.sectionTop = 0;
    this.sectionHeight = 0;
    this.scrollableHeight = 0;
    this.lastLoggedProgress = -1;
    
    if (!this.heroSection) {
      return;
    }
    
    if (!this.heroImage) {
      return;
    }
    
    this.init();
  }

  init() {
    if (this.heroImage.complete) {
      this.calculateDimensions();
      this.setupScrollAnimation();
    } else {
      this.heroImage.addEventListener('load', () => {
        this.calculateDimensions();
        this.setupScrollAnimation();
      });
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    window.addEventListener('resize', () => {
      this.calculateDimensions();
    });

    window.addEventListener('scroll', () => {
      this.updateAnimation();
    }, { passive: true });
  }

  calculateDimensions() {
    const wrapper = this.heroSection.querySelector('.about-hero__wrapper');
    const imageRect = this.heroImage.getBoundingClientRect();
    
    if (!wrapper) {
      return;
    }
    
    const wrapperRect = wrapper.getBoundingClientRect();
    
    const scaleToFillWidth = wrapperRect.width / imageRect.width;
    const scaleToFillHeight = wrapperRect.height / imageRect.height;
    this.maxScale = Math.max(scaleToFillWidth, scaleToFillHeight);
    
    this.sectionTop = this.heroSection.offsetTop;
    this.sectionHeight = this.heroSection.offsetHeight;
    
    this.scrollableHeight = window.innerHeight * 0.6;
  }

  setupScrollAnimation() {
    const totalHeight = this.sectionHeight + this.scrollableHeight;
    this.heroSection.style.minHeight = totalHeight + 'px';
  }

  updateAnimation() {
    const scrollY = window.scrollY;
    
    const sectionStart = this.sectionTop;
    const sectionEnd = this.sectionTop + this.sectionHeight + this.scrollableHeight;
    
    if (scrollY >= sectionStart && scrollY <= sectionEnd) {
      const scrollProgress = (scrollY - sectionStart) / this.scrollableHeight;
      this.animationProgress = Math.max(0, Math.min(1, scrollProgress));
      
      this.currentScale = this.initialScale + (this.animationProgress * (this.maxScale - this.initialScale));
      
      this.applyScaleToImage();
      
      const progressPercent = Math.round(this.animationProgress * 100);
      if (progressPercent % 5 === 0 && progressPercent !== this.lastLoggedProgress) {
        this.lastLoggedProgress = progressPercent;
      }
    }
  }

  applyScaleToImage() {
    if (!this.heroImage) return;
    
    this.heroImage.style.transform = `scale(${this.currentScale})`;
    this.heroImage.style.transformOrigin = 'center center';
    this.heroImage.style.transition = 'transform 0.1s ease-out';
    this.heroImage.style.willChange = 'transform';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AboutHeroScrollAnimation();
});
if (document.readyState !== 'loading') {
  new AboutHeroScrollAnimation();
}
